import { MutableRefObject, useEffect, useRef } from "react";

/**Use previous value ref hook. Useful for executing logic only if a value from state changed only once */
export function usePrevious(value : any) : MutableRefObject<any> {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref;
}